"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GraphTitle = require("../GraphTitle");

var _Loader = require("../Loader");

var _LazyCharts = require("../LazyCharts");

var _utils = require("../utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _AnalyticsDateFormatter = _interopRequireDefault(require("../AnalyticsDateFormatter"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelfServiceScoreOverTime = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SelfServiceScoreOverTime, _Component);

  var _super = _createSuper(SelfServiceScoreOverTime);

  function SelfServiceScoreOverTime() {
    var _this;

    (0, _classCallCheck2.default)(this, SelfServiceScoreOverTime);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: true,
      selfServiceScoreOverTime: []
    });
    return _this;
  }

  (0, _createClass2.default)(SelfServiceScoreOverTime, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchGraphData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchGraphData",
    value: function () {
      var _fetchGraphData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$this$props$fet, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return this.props.fetchData('/analyticsV2/selfServiceScoreOverTime');

              case 4:
                _yield$this$props$fet = _context2.sent;
                data = _yield$this$props$fet.data;
                this.setState({
                  selfServiceScoreOverTime: data,
                  isLoading: false
                });

              case 7:
                _context2.prev = 7;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(7);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 7, 10]]);
      }));

      function fetchGraphData() {
        return _fetchGraphData.apply(this, arguments);
      }

      return fetchGraphData;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shouldChartRedraw = _this$props.shouldChartRedraw,
          isSyncTicketDataActive = _this$props.isSyncTicketDataActive;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          selfServiceScoreOverTime = _this$state.selfServiceScoreOverTime;
      var data = {
        datasets: [{
          label: 'Ratio of unique visitors who viewed help content to unique users who created a ticket',
          fill: false,
          maxBarThickness: 500,
          data: selfServiceScoreOverTime.map(function (d) {
            return {
              x: d.time,
              y: d.count
            };
          }),
          backgroundColor: _utils.BRAND_BLUE
        }]
      };
      var options = {
        title: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 24
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          intersect: false,
          mode: 'nearest',
          callbacks: {
            title: function title(item) {
              if (item.length > 0 && item[0].label) {
                var date = new Date(item[0].label.substr(0, 10));

                _AnalyticsDateFormatter.default.getFormattedMonth(date);
              }

              return '';
            }
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            offset: true,
            time: {
              unit: 'month'
            }
          }],
          yAxes: [{
            gridLines: {
              borderDash: [8, 4],
              color: _utils.BRAND_BORDER_GREY,
              drawBorder: false
            },
            ticks: {
              padding: 16,
              beginAtZero: true
            }
          }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      };
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('graph-row', {
          'no-data': !isSyncTicketDataActive
        })
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Self-service score",
        tooltipMessage: "The ratio of unique visitors who viewed help content to unique users who created a ticket in the selected time period over time."
      }), !isSyncTicketDataActive ? (0, _preact.h)("div", {
        className: "data-not-tracked-text"
      }, "There\u2019s no data yet") : isLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: data,
        options: options
      }));
    }
  }]);
  return SelfServiceScoreOverTime;
}(_preact.Component);

var _default = SelfServiceScoreOverTime;
exports.default = _default;